import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { bisaTabPerInstalasi } from "@/lib/roles";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

// Switcher "Per Peserta" (/rotasi-klinik) <-> "Per Instalasi" (/rotasi-klinik/dashboard-instalasi).
// Sengaja 2 ROUTE terpisah (bukan satu halaman dgn TabsContent) supaya nanti role
// "Admin Instalasi" bisa diberi akses HANYA ke /rotasi-klinik/dashboard-instalasi
// lewat ProtectedRoute roles=[...] tanpa perlu logika sembunyikan-tab di JS.
//
// Switcher tampil utk bisaTabPerInstalasi (Super Admin, Admin UFP, Admin Prodi, Admin Koas -- dua yg
// terakhir sejak Okt 2026, datanya DIBATASI SERVER ke cakupan prodinya). Peran lain tidak dirender. Ini SEMBUNYIKAN, bukan mengamankan; penjaga sebenarnya tetap ProtectedRoute +
// require_monitoring_per_instalasi / _cakupan_prodi_per_instalasi di backend.
export default function RotasiKlinikViewTabs({ active }) {
    const navigate = useNavigate();
    const { user } = useAuth();
    if (!bisaTabPerInstalasi(user?.role)) return null;
    return (
        <Tabs value={active} onValueChange={(v) => navigate(v === "instalasi" ? "/rotasi-klinik/dashboard-instalasi" : "/rotasi-klinik")}>
            <TabsList>
                <TabsTrigger value="peserta" data-testid="rk-view-tab-peserta">Per Peserta</TabsTrigger>
                <TabsTrigger value="instalasi" data-testid="rk-view-tab-instalasi">Per Instalasi</TabsTrigger>
            </TabsList>
        </Tabs>
    );
}
